import React from 'react';
import HouseDetails2AboutProperty from "./HouseDetails2AboutProperty/HouseDetails2AboutProperty";
import './housedetails2bottom.scss'
import PremiumAmenities from "./PremiumAmenities/PremiumAmenities";
import HouseDetails2WalkThrough from "./HouseDetails2WalkThrough/HouseDetails2WalkThrough";
import HouseDetails2Sidebar from "./HouseDetails2Sidebar/HouseDetails2Sidebar";

const HouseDetails2Bottom = () => {
	return (
		<section className="HouseDetails2Bottom-main-grid">
			<div className="HouseDetails2Bottom-content-left">
				<HouseDetails2AboutProperty />
				<PremiumAmenities />
				<HouseDetails2WalkThrough />
			</div>
			<HouseDetails2Sidebar />
		</section>
	);
};

export default HouseDetails2Bottom;